import React, { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import LayoutWithHeader from "../components/LayoutWithHeader";
import ProfileStats, {
  StatsTimeDomainControls,
} from "../features/profile/ProfileStats.js";
import { useAuth } from "../context/authContext.js";
import { getContentLabel, getContentTypeFromSlug } from "../utils/utils.js";

/**
 * A user's full stats, reached from the Track page's summary strip, at
 * Track's width. The header carries the title ("Movie stats") and the time
 * span controls.
 *
 * The link carries that view's tab (`type`, `status`), filters and search
 * (`q`) as Track names them; only `type` is read so far, the rest waiting on
 * stats scoped to them. Movies have the only stats yet, so All opens on those.
 */
export default function Stats() {
  const { username } = useParams();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  // null for all-time, else a year
  const [timeDomain, setTimeDomain] = useState(null);
  const contentType =
    getContentTypeFromSlug(searchParams.get("type")) ?? "movie";

  return (
    <LayoutWithHeader
      title={`${getContentLabel({ type: contentType })} stats`}
      titleAdornment={
        <StatsTimeDomainControls
          timeDomain={timeDomain}
          onTimeDomainChange={setTimeDomain}
        />
      }
      showBackButton
      maxWidth="lg"
    >
      <ProfileStats
        username={username}
        contentType={contentType}
        isOwnProfile={user?.username === username}
        timeDomain={timeDomain}
      />
    </LayoutWithHeader>
  );
}
